import LookupService from "../../services/LookupService"
import ACTIONS from '../actionTypes/lookupData'

export const getAllApiResources = () => {
  return (dispatch) => {
    return LookupService.getAllApiResources().then((res) => {
      if (res.data && Array.isArray(res.data)) {
        // Mapping to data format which MultiSelectField expects
        const allApiResources = 
          res.data?.filter(r => r?.scopes?.length > 0).map(r => ({
            value: r.name,
            list: r.scopes?.map(s => ({ value: s.name }))  
          }))

        dispatch({ 
          type: ACTIONS.GET_ALL_API_RESOURCES_SUCCESS, 
          payload: allApiResources ?? []
        })
      }
    }).catch(() => { /* Fail silently */})
  }
}

export const getAllApplicationCategories = () => {
  return (dispatch) => {
    return LookupService.getAllApplicationCategories().then((res) => {
      if (res.data && Array.isArray(res.data)) {
        // Mapping to data format which SelectField expects
        const allApplicationCategories = res.data?.map(c => ({ value: c.id, displayName: c.name }))
        
        dispatch({ 
          type: ACTIONS.GET_ALL_APPLICATION_CATEGORIES_SUCCESS, 
          payload: allApplicationCategories ?? []
        })
      }
    }).catch(() => { /* Fail silently */})
  }
}

export const getProductPropertyFormats = (categoryName) => {

  return (dispatch) => { 
    dispatch({ type: ACTIONS.START_GET_PRODUCT_PROPERTY_FORMATS })

    return LookupService.getProductPropertyFormats(categoryName).then((res) => {
      if (res.data) {
        dispatch({ type: ACTIONS.GET_PRODUCT_PROPERTY_FORMATS_SUCCESS, payload: res.data })
      } else {
        dispatch({ type: ACTIONS.GET_PRODUCT_PROPERTY_FORMATS_FAILED })
      }
    }).catch(() => {
      dispatch({ type: ACTIONS.GET_PRODUCT_PROPERTY_FORMATS_FAILED })
    })
  }
}

export const getAllPlatforms = () => {
  return (dispatch) => {
    return LookupService.getAllPlatforms().then((res) => {
      if (res.data) {
        // Mapping to data format which MultiSelectField expects
        const allPlatforms = Array.isArray(res.data) ? res.data?.map(p => ({ value: p.code, displayName: p.name })) : []
        
        dispatch({ 
          type: ACTIONS.GET_ALL_PLATFORMS_SUCCESS, 
          payload: allPlatforms ?? []
        })
      }
    }).catch(() => { /* Fail silently */})
  }
}
